export function pages(site) {
    return safe(() => site['pages']) || [];
}

export function block(container, name) {
    return safe(() => container['blocks'][name]) || {};
}

export function blocklist(block, name) {
    return safe(() => block['blocklists'][name]['blocks']) || [];
}

export function image(block, name, size = [null, null]) {
    var content = safe(() => block['contents'][name]) || {};
    switch (content['mime']) {
      case 'image/svg':
            return content['image'];
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
      case 'image/tiff':
          var [w, h] = size.map(x => x ? x : "_");
          return content['image'] + "?" + "d=" + w + "x" + h;
      default:
          console.warn("Unsuported MIME: " + content['mime'] + " for " + name);
          return null;
    }
}

export function text(block, name) {
    return safe(() => block['contents'][name]['text']) || "";
}

export function richtext(block, name) {
    return safe(() => block['contents'][name]['richtext']) || "";
}

export function url(block, name) {
    return safe(() => block['contents'][name]['url']) || "#";
}

export function safe(f) {
    try {
        return f();
    } catch(e) {
        return undefined;
    }
}

export function exists(block, name) {
    return block['contents'][name] !== undefined;
}

export function video(block, name, size = 'orig') {
    return safe(() => block['contents'][name]['video'][size]) || "#";
}

export function style(block, rest = "") {
    let padding = () => {
        let default_pads = [5, 0, 5, 0];
        let block_pads;
        try {
            block_pads = block.style.padding;
        }
        catch(e) {
            block_pads = [0, 0, 0, 0];
        }
        let final_pads = [];
        for(let i = 0; i < default_pads.length; i++){
            final_pads.push(default_pads[i] + block_pads[i]);
        }
        return "padding:" + final_pads.join("em ");
    };

    return [padding(), rest].join(";");
}

export function submitMessage(ev) {
    const mailer_endpoint = 'https://gorgeous.works/mailer',
          recaptcha = '6LfVGccbAAAAAKOVFTJw_tJrQBazrYDuHejx-BvN',
          form = ev.target;
    ev.preventDefault();
    grecaptcha.ready(function() {
        grecaptcha.execute(recaptcha, {action: 'submit'}).then(function(token) {
            const XHR = new XMLHttpRequest(),
                  FD  = new FormData(form);
            FD.append("token", token);
            XHR.addEventListener('load', function( event ) {
                if (XHR.status === 200) {
                    form.classList.remove("was-validated");
                    form.reset();
                    alert( 'Your message has been sent, thank you for your inquiry.' );
                }
                else if (XHR.status === 400) { alert(XHR.responseText); }
                else { alert( 'Something went wrong, please try again.' ); }
            });
            XHR.addEventListener('error', function( event ) {alert( 'Oops! Something went wrong.' );});
            XHR.open('POST', mailer_endpoint);
            XHR.send(FD);
        });
    });
}
